import './_style.scss'
import Listener from '../../core/watcher/Listener'

Listener.onLoadDOM(() => {
   const playBlockRef = document.querySelector('.youtubeVideoPlayBlock')
   const videoBlockRef = document.querySelector('.youtubeVideoImageBlock')
   const youtubeImageRef = document.querySelector('.youtubeVideoImage')
   if (playBlockRef) {
      const figureRef = `<figure class='youtubeVideoFigure'>
                              <iframe src='https://www.youtube.com/embed/${videoBlockRef?.dataset?.videoId}?autoplay=1' 
                              frameborder='0' allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' 
                              allowfullscree></iframe>
                         </figure>`

      playBlockRef.addEventListener('click', () => {
         playBlockRef.classList.add('youtubeVideoPlayBlock--hide')
         youtubeImageRef?.classList.add('youtubeVideoImage--hide')
         setTimeout(() => {
            videoBlockRef?.insertAdjacentHTML('beforeend', figureRef)
         }, 200)
      })
   }
})